import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import DashboardWidgetFrequentPassageRequests from '@legacy-components/admin/dashboardWidgets/DashboardWidgetFrequentPassageRequests';

import { userHasPermission as p } from '../../libs/utils';
import { selectUser } from '../../redux/auth/selectors';
import AdminSubHeader from '../layouts/partials/AdminSubheader';
import DashboardWidgetMaterialRequests from './dashboardWidgets/DashboardWidgetMaterialRequests';
import DashboardWidgetRegistration from './dashboardWidgets/DashboardWidgetRegistrations';
import DashboardWidgetTransportRequests from './dashboardWidgets/DashboardWidgetTransportRequests';
import DashboardWidgetSafetyQuestionAnswerApproval
  from "@legacy-components/admin/dashboardWidgets/DashboardWidgetSafetyQuestionAnswerApproval";

class _Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  static propTypes = {
    user: PropTypes.object,
  };

  render() {
    const { user } = this.props;

    return (
      <div>
        <AdminSubHeader title="Dashboard" />
        <div className="m-content" key="content">
          <div className="row">
            {p(user, ['registrations.registrations']) && (
              <div className="col-md-6">
                <DashboardWidgetSafetyQuestionAnswerApproval />
              </div>
            )}

            {p(user, ['registrations.registrations']) && (
              <div className="col-md-6">
                <DashboardWidgetRegistration />
              </div>
            )}
            {p(user, ['registrations.registrations']) && (
              <div className="col-md-6">
                <DashboardWidgetMaterialRequests />
              </div>
            )}
            {p(user, ['registrations.registrations']) && (
              <div className="col-md-6">
                <DashboardWidgetTransportRequests />
              </div>
            )}
            {p(user, ['gatekeeping.frequentPassages']) && (
              <div className="col-md-6">
                <DashboardWidgetFrequentPassageRequests />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    user: selectUser(state),
  };
};

const mapDispatchToProps = (dispatch) => ({});

const Dashboard = connect(mapStateToProps, mapDispatchToProps)(_Dashboard);

export default Dashboard;
